import { getCurrentInstance } from 'vue';

const resolveProxy = () => {
  const instance = getCurrentInstance();
  if (!instance || !instance.proxy) {
    throw new Error('useLegacyGlobals must be called within setup().');
  }
  return instance.proxy;
};

export const useLegacyProxy = () => resolveProxy();

export const useLegacyStore = () => resolveProxy().$store;

export const useLegacyRouter = () => resolveProxy().$router;

export const useLegacyRoute = () => resolveProxy().$route;

export const useLegacyI18n = () => resolveProxy().$i18n;

export const useLegacyEmit = () => resolveProxy().$emit;
